import { Zap, BadgeCheck, Lock } from "lucide-react"

export function WhySourceWithEnga() {
  return (
    <div className="border-t border-outline-variant/30 pt-10">
      <h3 className="text-[18px] font-semibold text-center text-slate-800 mb-6">Why source with Enga?</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white border border-[#f1e0de] p-6 rounded-2xl flex items-start gap-4 hover:shadow-sm transition-shadow">
          <Zap className="size-6 text-[#be001e] shrink-0 mt-0.5" />
          <div>
            <h4 className="text-[15px] font-semibold text-on-surface mb-1">AI-powered matching</h4>
            <p className="text-secondary text-[13px] leading-[18px]">Our neural engine analyzes your requirements to find the perfect production partner.</p>
          </div>
        </div>
        <div className="bg-white border border-[#f1e0de] p-6 rounded-2xl flex items-start gap-4 hover:shadow-sm transition-shadow">
          <BadgeCheck className="size-6 text-[#be001e] shrink-0 mt-0.5" />
          <div>
            <h4 className="text-[15px] font-semibold text-on-surface mb-1">Verified sellers</h4>
            <p className="text-secondary text-[13px] leading-[18px]">Every supplier on Enga undergoes a multi-stage KYC and factory audit process.</p>
          </div>
        </div>
        <div className="bg-white border border-[#f1e0de] p-6 rounded-2xl flex items-start gap-4 hover:shadow-sm transition-shadow">
          <Lock className="size-6 text-[#be001e] shrink-0 mt-0.5" />
          <div>
            <h4 className="text-[15px] font-semibold text-on-surface mb-1">Privacy protected</h4>
            <p className="text-secondary text-[13px] leading-[18px]">Share requirements anonymously. Your contact data is only released to your choice.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
